import React from 'react'

const FacebookMessenger = () => {
  return (
    <>
      <div id="fb-root" />
      <div
        className="fb-customerchat"
        {...({ attribution: 'setup_tool', page_id: '1135488086472865', greeting_dialog_display: 'hide' } as React.HTMLAttributes<HTMLDivElement>)}
      />
    </>
  )
}

export default FacebookMessenger
